import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-24 right-4 lg:bottom-8 lg:right-8 z-40 p-3 lg:p-4 bg-gradient-to-r from-maroon-700 to-maroon-900 text-white rounded-full shadow-2xl hover:from-gold-500 hover:to-gold-600 transition-all duration-300 hover:scale-110 group"
          aria-label="Back to top"
        >
          <FaArrowUp className="text-lg lg:text-xl group-hover:animate-bounce" />
        </button>
      )}
    </>
  );
};

export default BackToTop;
